import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
export const insuranceModStyles = makeStyles()((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  providerLb: {
    fontSize: '12px !important',
    fontWeight: 'bold',
    marginRight:'24px'
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    
  },
  gridRow: {
    paddingTop: '24px',
    '& .MuiInputBase-root.Mui-disabled': {
      background: '#FFFF;',
      color: '#333333 !important',
    },
    '& .MuiFormControlLabel-label.Mui-disabled':{
      color: '#333333 !important',
    }
  },
  inputFields: {
    minWidth: '245px',
    '& .MuiInputLabel-root-inputFields.Mui-disabled': {
      color: '#333333 !important',
    },
    '& .MuiFormHelperText-root': {
      width: 'max-content !important',
    },
  },
  dateContainer: {
    '& .MuiInputBase-root.Mui-disabled': {
      background: '#FFFF;',
      color: '#333333 !important',
    },
    '& .MuiFormHelperText-root': {
      width: 'max-content !important',
    },
    minWidth: '350px',
  },
}));
